import Chip from "@mui/material/Chip";
import { jsx as _jsx } from "react/jsx-runtime";
export function TBadge(props) { if (!props.count)
    return null; return /*#__PURE__*/ _jsx(Chip, { size: "small", color: "secondary", style: { fontSize: "0.7rem", fontWeight: "bold", paddingTop: 4, paddingBottom: 4, height: 16 }, label: props.count }); }
